import React, { useEffect, useState } from "react";

export default function CookieConsent() {
    const [visible, setVisible] = useState(false);

    const applyConsent = () => {
        if (window.gtag) {
            window.gtag('consent', 'update', {
                'ad_storage': 'granted',
                'analytics_storage': 'granted',
                'functionality_storage': 'granted',
                'personalization_storage': 'granted',
                'security_storage': 'granted',
            });

            // Re-initialize GA with default cookie lifetime (2 years)
            window.gtag('config', 'G-MWZWRYQQTW');
        }
    };

    useEffect(() => {
        const consent = localStorage.getItem("cookie_consent");
        if (consent !== "true" && consent !== "false") {
            setVisible(true);
        } else if (consent === "true") {
            applyConsent();
        }
    }, []);

    const handleAccept = () => {
        localStorage.setItem("cookie_consent", "true");
        setVisible(false);
        applyConsent();
    };

    const handleReject = () => {
        setVisible(false);
        localStorage.setItem("cookie_consent", "false"); // Optional
    };

    if (!visible) return null;

    return (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
            <div className="relative bg-white text-gray-800 p-6 rounded-lg shadow-lg max-w-sm w-full text-center space-y-4">
                <h2 className="text-lg font-semibold">Sütik engedélyezése</h2>
                <p className="text-sm">
                    Weboldalunk sütiket használ a működéshez és statisztikai célokra. Kérjük, fogadd el a használatukat.
                </p>
                <button
                    onClick={handleAccept}
                    className="bg-green-600 hover:bg-green-700 text-white px-5 py-2 rounded"
                    aria-label="Sütik elfogadása"
                >
                    Elfogadom
                </button>

                {/* ❌ X gomb – bal alsó sarokban */}
                <button
                    onClick={handleReject}
                    className="absolute bottom-2 left-2 text-gray-500 hover:text-gray-700 text-2xl font-bold"
                    aria-label="Sütik elutasítása"
                >
                    ✕
                </button>
            </div>
        </div>
    );
}
